
export const NOTIFICATION_CREATE = "NOTIFICATION_CREATE";
export const NOTIFICATION_CREATE_SUCCESS = "NOTIFICATION_CREATE_SUCCESS";
export const NOTIFICATION_CREATE_ERROR = "NOTIFICATION_CREATE_ERROR";
export const NOTIFICATIONS_LIST_FILTERED = "NOTIFICATIONS_LIST_FILTERED";
export const NOTIFICATIONS_LIST_FILTERED_SUCCESS = "NOTIFICATIONS_LIST_FILTERED_SUCCESS";
export const NOTIFICATIONS_LIST_FILTERED_ERROR = "NOTIFICATIONS_LIST_FILTERED_ERROR";
export const NOTIFICATION_SET_VIEWED = "NOTIFICATION_SET_VIEWED";
export const NOTIFICATION_SET_VIEWED_SUCCESS = "NOTIFICATION_SET_VIEWED_SUCCESS";
export const NOTIFICATION_SET_VIEWED_ERROR = "NOTIFICATION_SET_VIEWED_ERROR";